import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header-container">
      <img className="logo" src="/logo.png" alt="logo" />

      {/* Desktop Menu */}
      <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
        <Link to="/services" onClick={() => setMenuOpen(false)}>York Region Applications</Link>
        <Link to="/parcels" onClick={() => setMenuOpen(false)}>Parcels</Link>
        <Link to="/articles" onClick={() => setMenuOpen(false)}>Articles</Link>
        <Link to="/dashboard" onClick={() => setMenuOpen(false)}>Dashboard</Link>
        <Link to="/municipality-map" onClick={() => setMenuOpen(false)}>municipalities map</Link>
        <Link to="/score-criteria">Score Criteria</Link>
        <Link to="/news" onClick={() => setMenuOpen(false)}>News</Link>
        <Link to="/events" onClick={() => setMenuOpen(false)}>Events</Link>
      </nav>

      <button className="contact-btn">Contact Us</button>

      {/* Mobile Hamburger */}
      <div
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen((p) => !p)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
}
